<template>
    <div v-bind:class="className + ' editable-field' + (active ? ' active' : '')" title="Click to edit">
        <span class="editable-field__show" v-on:click="edit()">
            {{ content }}
            <i class="overlay-icon fa fa-pencil"></i>
        </span>
        <div class="editable-field__edit">
            <div>
                <input type="text" v-model="content" ref="input">
            </div>
            <div class="save-options" tabindex="1">
                <button type="submit" v-on:click="save()">
                    <i class="material-icons">check</i>
                </button>
                <button type="button" v-on:click="cancel()">
                    <i class="material-icons">close</i>
                </button>
            </div>
        </div>
    </div>
</template>

<style>
    .editable-field {
        background-color: #fff;
        transition: box-shadow 150ms ease-in 0ms;
        cursor: text;
        display: inline-block;
        position: relative;
        vertical-align: top;
        word-break: break-word;
        max-width: 100%;
        width: 100%;
    }

    .editable-field .overlay-icon {
        font-size: 14px;
        text-align: center;
        color: #707070;
        opacity: 0;
        -moz-box-sizing: border-box;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        border-left: 1px solid #ccc;
        background-color: #f0f0f0;
        cursor: pointer;
        width: 24px;
        height: auto;
        padding-top: 5px;
        position: absolute;
        right: 0;
        bottom: 0;
        top: 0;
        transition: opacity 150ms ease-in 0ms;
        z-index: -1;
    }

    .editable-field:hover {
        box-shadow: 0 0 0 1px #ccc;
    }

    .editable-field:hover .overlay-icon {
        opacity: 1;
        z-index: auto;
    }

    .editable-field .save-options {
        background-color: #f0f0f0;
        border: 1px solid #ccc;
        border-top: none;
        box-shadow: 0 3px 6px rgba(111,111,111,0.2);
        outline: none;
        padding: 3px;
        margin-right: -1px;
        position: absolute;
        right: 0;
        top: 100%;
        z-index: 1;
    }

    .editable-field.active {
        box-shadow: 0 0 0 1px #ccc;
    }

    .editable-field:hover.active .overlay-icon {
        opacity: 0;
    }

    .editable-field input {
        border: 0;
        width: 100%;
    }

    .editable-field__show {
        display: block;
    }

    .editable-field__edit {
        display: none;
    }

    .editable-field.active .editable-field__show {
        display: none;
    }

    .editable-field.active .editable-field__edit {
        display: block;
    }
</style>

<script>
    export default {
        props: {
            value: {
                type: String,
                default: 'value',
                required: true
            },
            className: {
                type: String,
                default: null
            }
        },

        data() {
            return {
                content: this.value,
                originalContent: null,
                active: false
            }
        },

        watch: {
            value(val) {
                this.content = val;
                this.originalContent = null;
            }
        },

        methods: {
            edit() {
                if (!this.active) {
                    this.originalContent = this.content;
                    this.$nextTick(function() {
                        $(this.$refs.input).select();
                    });
                }
                this.active = true;
            },

            save() {
                this.active = false;
                this.$emit('update', String(this.content))
            },

            cancel() {
                this.content = this.originalContent;
                this.originalContent = null;
                this.active = false;
            }
        }
    }
</script>
